import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { NotStartedSplitTestInterface, SplitTestInterface } from 'modules/funnels/funnel/types/funnel-tests-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export function useFunnelStepTests(funnelStepId) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== funnelStepId || $[2] !== user) {
    t1 = () => {
      if (user && funnelStepId) {
        return [`${FUNNELS_API}/steps/${funnelStepId}/split-test`, RequestModuleEnum.FunnelsStep];
      }
      return null;
    };
    $[1] = funnelStepId;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: splitTestData,
    mutate: mutateSplitTest
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[4] !== mutateSplitTest || $[5] !== splitTestData) {
    t2 = {
      splitTestData,
      mutateSplitTest
    };
    $[4] = mutateSplitTest;
    $[5] = splitTestData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}